const levelOptions = [
	{ id: 'low', description: 'Low' },
	{ id: 'medium', description: 'Medium' },
	{ id: 'high', description: 'Advanced' },
]

export default levelOptions
